<template>
  <div style="max-width:900px; margin: auto;">
 <br />
  
    <h2>{{ $t('Recordings') }} </h2>
 
   <hr />
   
    <div v-if="recordingsList">
  
     <p v-if="recordingsList.length==0"> {{ $t('NoPastBroadcast') }}</p>
<div class="row">

  <div class="col-md-3 p-2" v-for="recording in recordingsList" v-bind:key="recording.session" >
      <recording :recording="recording" :channel_id="channel.id" v-bind:onclick="'window.location = \'/broadcaster/recording/'+recording.session+'\''" >
    </recording> 
</div>
 <button  v-if="isMore" @click="getMoreRecordings()" class="btn btn-dark m-2 btn-block">{{ $t('load-more-recordings') }}</button>
</div>
</div>
<div v-else>
  <p class="w-100 text-center"> {{ $t('LoadingPastBroadcasts') }}...</p> 
               <scale-loader  :color="'darkblue'" ></scale-loader>

   </div>
</div>


</template>

<script>

import recording from '../Recording.vue'
import axios from "axios"
import Swal from "sweetalert2"
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'

let API = "https://app.seasoncast.com/"

export default {
  name: 'Home',
  props: ['channel'],
  components: {
    recording,
    ScaleLoader
  },
  
  data: function () {
    return {
      recordingsList: undefined,
        eventList: [],
        currentEnd: 150,
        isMore: false,
        ScaleLoader
    }
  },
   watch: {
    channel: function () {
      this.getChannelRecordings()
    }
  },
  created: async function () {


await this.getChannelRecordings()

  },
  methods: {
    getChannelRecordings: async function () {
      console.log(this.channel.id)
    let getEventResponse = await axios.post(API+ "v2/channel/recordings", {
    channel_id: this.channel.id,
    start: 0,
    end: this.currentEnd,
    stats: true
  }) 

  let responseData = getEventResponse.data

  if (!responseData.success){
       await Swal.fire({
  icon: 'error',
  title: 'Error',
  text: 'message: '+JSON.stringify(responseData.reason),
  footer: this.$t('try-action-later-or-refresh-page')
})

  }
console.log(responseData)
  this.recordingsList = responseData.recordings
this.isMore = responseData.isMore


    },
      getMoreRecordings: async function(){
this.currentEnd += 300
this.getChannelRecordings()
  }
  },

}
</script>
<style lang="scss">
.container {
    max-width: 1100px;
}
</style>
